export default {
  topic_search_circle: 'No{keyword} related circles found',
}
